import { computed, onBeforeMount, ref, toValue } from 'vue'
import useConfig from '../useConfig'
import useSubscriberApi from './useSubscriberApi.ts'

const subscriber = ref<Subscriber | null>(null)

export default function useSubscriber() {
  const { get } = useSubscriberApi()
  const { internalName } = useConfig()

  const credentialLoginAllowed = computed<boolean>(() => {
    if (subscriber.value === null) {
      return true
    }

    return subscriber.value.credentialLoginAllowed === true
  })

  async function fetchSubscriber() {
    try {
      subscriber.value = await get(toValue(internalName))
    } catch (error) {
      console.error(`Failed to fetch subscriber "${toValue(internalName)}".`, { error })
    }

    return subscriber.value
  }

  onBeforeMount(async () => {
    if (subscriber.value === null) {
      await fetchSubscriber()
    }
  })

  return {
    // Computed
    credentialLoginAllowed,
  }
}
